module.exports = __webpack_public_path__ + "img/pharmacy.770a6eec.png";